import { Link, NavLink } from "react-router-dom";
import { ModeToggle } from "@/components/theme-toggle";
import { Button } from "@/components/ui/button";

export default function NavBar() {
  return (
    <header className="sticky top-0 z-10 border-b bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4">
        <Link to="/" className="font-semibold">FanzBots</Link>
        <nav className="hidden items-center gap-6 text-sm text-muted-foreground sm:flex">
          <NavLink to="/" className={({isActive})=> isActive?"text-foreground":"hover:text-foreground"}>Home</NavLink>
          <NavLink to="/create" className={({isActive})=> isActive?"text-foreground":"hover:text-foreground"}>Create</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild size="sm"><Link to="/create">Create a bot</Link></Button>
          <ModeToggle />
        </div>
      </div>
    </header>
  );
}
